<!-- 零售发货单详情-修改发票信息 -->
<template>
  <div class="OC_B_ORDER_INVOICE cus-modal" v-loading="loading">
    <div class="obj-main">
      <div class="obj-form">
        <Collapse v-model="openDefault">
          <Panel :name="String(index)" v-for="(panel, index) in panelArr" :key="panel.parentname">
            {{ panel.parentdesc }}
            <p slot="content">
              <OmsForm :form-config="form[panel.parentname]" />
            </p>
          </Panel>
        </Collapse>
      </div>
    </div>
    <OmsButton class="modal-footer" :btn-config="btnConfig" />
  </div>
</template>

<script>
import cusMixin from '@/config/minxin/singleObjectCustomize'

export default {
  name: 'ChangeInvoice',
  props: {
    objId: {
      type: String,
    },
    componentData: {
      type: Object
    }
  },
  mixins: [cusMixin()],
  data() {
    return {
      loading: false,
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            size: 'small', // 按钮大小
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            text: t('确定'),
            type: 'primary',
            size: 'small', // 按钮大小
            btnclick: () => {
              this.confirm();
            }, // 按钮点击事件
          }
        ],
      },
    }
  },
  computed: {
    mainForm() {
      let form = { formData: [], formValue: {}, ruleValidate: {}}
      for (let key in this.form) {
        form.formData = form.formData.concat(this.form[key].formData)
        Object.assign(form.formValue, this.form[key].formValue)
        Object.assign(form.ruleValidate, this.form[key].ruleValidate)
      }
      return form
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const arg = { 
        tableName: 'OC_B_ORDER_INVOICE', 
        objId: this.componentData.invoiceId, 
        styleSpan: false, 
        parentname: "(OC_B_ORDER_INVOICE.ID+100)" 
      }
      this.getObject(arg, (base, form) => {
        if (this.componentData) {
          Object.keys(form).forEach((key, index) => {
            form[key].formData.forEach(item => {
              item.width = '12'
            });
          })
        }
      })
    },
    confirm() {
      console.log(this)
      let flag = false
      for (let i of this.mainForm.formData) {
        const rv = this.mainForm.ruleValidate
        if ((rv && rv[i.value] && rv[i.value][0].required) && this.mainForm.formValue[i.value] == '') {
          flag = true
          $fcError(t('{}不能为空', i.label))
          break;
        }
      }
      if (flag) return
      const params = {
        ORDER_ID: this.componentData.id,
        ID: this.componentData.invoiceId,
        ...this.mainForm.formValue
      }
      this.service.common.publicUrlParams('/api/cs/oc/oms/v1/invoice/modify', params).then(res => {
        if (res.data.code == 0) {
          this.$Message.success(res.data.message);
          this.$parent.$parent.closeConfirm();
          const tab = this.$parent.$parent.$parent.queryTab('OC_B_ORDER_INVOICE')
          this.$parent.$parent.$parent.labelClick(tab); // 刷新子表
        }
      })
    },
  }
};
</script>
<style lang="less" scoped>
.cus-modal {
  /deep/ .business-form-main .ark-form .ark-form-item {
    padding-top: 6px !important;
  }
  .obj-main {
    max-height: 75vh;
    overflow: auto;
  }
}
</style>
